export default {
    brewName: 0,
    brewer: 1,
    brewNumber: 2,
    myVotes: 3,
    abv: 4
};